<div
  class="logo-container"
  [ngClass]="{ 'logo-home': this.currentRoute === '/inicio' }"
>
  <img src="assets/img/logo_cat_nav.png" alt="Arquitectos Tabasqueños" />
</div>
